import { db } from "../../../config/firebaseconfig";
import updateAllGroupUAsWithStudentAll from "../../assessment/updateAllGroupUAsWithStudentAll";
import markGUAsAsNeedingUpdateAll from "../../assessment/markGUAsAsNeedingUpdateAll";
import assignTeacherToStudent from '../../assessment/assignTeacherToStudent';
export default function assignToClass(student, record, notInClass) {


  const batch = db.batch()
  const studentRef = db.collection('students').doc(student.id)
  const classRef = db.collection('classes').doc(record.id)
  const classKey = `students.${student.id}`
  const studentKey = `classes.${record.id}`
  const teacherKey = `teachers.${record.teacher}`




  batch.update(classRef, { [classKey]: !!notInClass })
  batch.update(studentRef, { [studentKey]: !!notInClass })
  if (!notInClass) {
    assignTeacherToStudent(record,student);
  } else {
    batch.update(studentRef, {[teacherKey]: !!notInClass })
  }

  const p1 = batch.commit()
  const p2 = markGUAsAsNeedingUpdateAll(student, 2018)

  return Promise.all([p1, p2])
  // .then(() => {
  //   updateAllGroupUAsWithStudentAll(student, 2018)
  //     .catch(err => console.log(err))
  // })
  // return batch.commit()
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/assignToClass.js